import { z } from 'zod';

import { Option } from '../../types/Option';

export enum AcGroundingConfigurationEnum {
    TN_S = 'TN-S',
    TN_C = 'TN-C',
    IT = 'IT',
    TT = 'TT',
    UNEARTHED = 'unearthed',
}

export enum DcGroundingConfigurationEnum {
    TN_S = 'TN-S',
    IT = 'IT',
    UNEARTHED = 'unearthed',
    SYMMETRICAL_IMPEDANCE = 'symmetrical-impedance',
}

export const isSymmetricalImpedance = (configuration: string | null | undefined): boolean =>
    configuration === DcGroundingConfigurationEnum.SYMMETRICAL_IMPEDANCE;

const AcOptions: Option<AcGroundingConfigurationEnum>[] = [
    { value: AcGroundingConfigurationEnum.TN_S, label: 'TN-S' },
    { value: AcGroundingConfigurationEnum.TN_C, label: 'TN-C' },
    { value: AcGroundingConfigurationEnum.IT, label: 'IT' },
    { value: AcGroundingConfigurationEnum.TT, label: 'TT' },
    { value: AcGroundingConfigurationEnum.UNEARTHED, label: 'Floating' },
];

const DcOptions: Option<DcGroundingConfigurationEnum>[] = [
    { value: DcGroundingConfigurationEnum.TN_S, label: 'TN-S' },
    { value: DcGroundingConfigurationEnum.IT, label: 'IT' },
    { value: DcGroundingConfigurationEnum.SYMMETRICAL_IMPEDANCE, label: 'Symmetrical impedance' },
    { value: DcGroundingConfigurationEnum.UNEARTHED, label: 'Floating' },
];

const AcGroundingConfiguration = {
    validator: z
        .enum([
            AcGroundingConfigurationEnum.TN_S,
            AcGroundingConfigurationEnum.TN_C,
            AcGroundingConfigurationEnum.IT,
            AcGroundingConfigurationEnum.TT,
            AcGroundingConfigurationEnum.UNEARTHED,
        ])
        .nullable()
        .default(null),
    options: AcOptions,
};

const DcGroundingConfiguration = {
    validator: z
        .enum([
            DcGroundingConfigurationEnum.TN_S,
            DcGroundingConfigurationEnum.IT,
            DcGroundingConfigurationEnum.UNEARTHED,
            DcGroundingConfigurationEnum.SYMMETRICAL_IMPEDANCE,
        ])
        .nullable()
        .default(null),
    options: DcOptions,
};

const BusGroundingConfiguration = {
    validator: z
        .enum([
            AcGroundingConfigurationEnum.TN_S,
            AcGroundingConfigurationEnum.TN_C,
            AcGroundingConfigurationEnum.IT,
            AcGroundingConfigurationEnum.TT,
            AcGroundingConfigurationEnum.UNEARTHED,
            DcGroundingConfigurationEnum.SYMMETRICAL_IMPEDANCE,
        ])
        .nullable()
        .default(null),
};

export { AcGroundingConfiguration, BusGroundingConfiguration, DcGroundingConfiguration };
